// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.authlayout_container__uoTMi {
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: white;
}
.authlayout_container__uoTMi .authlayout_leftContainer__eyzoe {
  width: 40%;
  height: 100vh;
  background-color: white;
  display: flex;
  justify-content: center;
  position: relative;
}
@media screen and (max-width: 992px) {
  .authlayout_container__uoTMi .authlayout_leftContainer__eyzoe {
    width: 100%;
  }
}
.authlayout_container__uoTMi .authlayout_rightContainer__9xCzB {
  width: 60%;
  height: 100vh;
  background-color: rgb(239, 240, 249);
}
@media screen and (max-width: 992px) {
  .authlayout_container__uoTMi .authlayout_rightContainer__9xCzB {
    display: none;
  }
}
@media screen and (max-width: 565px) {
  .authlayout_container__uoTMi {
    justify-content: center;
    padding: 10px !important;
  }
}
.authlayout_container__uoTMi .authlayout_childerContainer__wATN1 {
  width: -moz-fit-content;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}
.authlayout_container__uoTMi .authlayout_childerContainer__wATN1 .authlayout_space__8shbY {
  height: 100px;
}
@media screen and (max-width: 992px) {
  .authlayout_container__uoTMi .authlayout_childerContainer__wATN1 {
    padding: 10px;
    width: 60%;
  }
}
@media screen and (max-width: 565px) {
  .authlayout_container__uoTMi .authlayout_childerContainer__wATN1 {
    padding: 10px;
    min-width: 300px;
    width: 90%;
    margin: 40px auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/layout/authlayout.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,WAAA;EAEA,aAAA;EAEA,mBAAA;EACA,uBAAA;AADJ;AAGI;EACI,UAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EAEA,uBAAA;EAEA,kBAAA;AAHR;AAIQ;EATJ;IAUQ,WAAA;EADV;AACF;AAII;EACI,UAAA;EACA,aAAA;EACA,oCAAA;AAFR;AAIQ;EALJ;IAMI,aAAA;EADN;AACF;AAMI;EAnCJ;IAoCQ,uBAAA;IACA,wBAAA;EAHN;AACF;AAKI;EAGI,uBAAA;EAAA,kBAAA;EACA,iBAAA;EACA,kBAAA;AALR;AAMQ;EACI,aAAA;AAJZ;AAUQ;EAbJ;IAcQ,aAAA;IAEA,UAAA;EARV;AACF;AAYQ;EArBJ;IAsBQ,aAAA;IACA,gBAAA;IACA,UAAA;IACA,iBAAA;EATV;AACF","sourcesContent":[".container {\n    height: 100vh;\n    width: 100%;\n    // background-color: rgba(239, 240, 249, 1);\n    display: flex;\n    // flex-direction: column;\n    align-items: center;\n    background-color: white;\n\n    .leftContainer {\n        width: 40%;\n        height: 100vh;\n        background-color: white;\n        display: flex;\n        // align-items: center;\n        justify-content: center;\n        // flex-direction: column;\n        position: relative;\n        @media screen and (max-width:992px) {\n            width: 100%;\n          }\n    }\n\n    .rightContainer {\n        width: 60%;\n        height: 100vh;\n        background-color: rgba(239, 240, 249, 1);\n        \n        @media screen and (max-width:992px) {\n        display: none;\n\n        }\n\n    }\n\n    @media screen and (max-width:565px) {\n        justify-content: center;\n        padding: 10px !important;\n    }\n\n    .childerContainer {\n        // border-radius: 20px;\n        // margin-top: 40px;\n        width: fit-content;\n        margin-left: auto;\n        margin-right: auto;\n        .space{\n            height: 100px;\n        }\n        // padding: 40px;\n\n        // border: 1px red solid;\n\n        @media screen and (max-width:992px) {\n            padding: 10px;\n            // min-width: 300px;\n            width: 60%;\n            // margin:40px auto;\n\n        }\n\n        @media screen and (max-width:565px) {\n            padding: 10px;\n            min-width: 300px;\n            width: 90%;\n            margin:40px auto;\n\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `authlayout_container__uoTMi`,
	"leftContainer": `authlayout_leftContainer__eyzoe`,
	"rightContainer": `authlayout_rightContainer__9xCzB`,
	"childerContainer": `authlayout_childerContainer__wATN1`,
	"space": `authlayout_space__8shbY`
};
export default ___CSS_LOADER_EXPORT___;
